const KEY = "rp_demo_attr";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch { /* ignore */ } };

export const recordDemoOpen = (kind, source) => {
  const a = read(); const k = kind || "both"; const now = new Date().toISOString();
  a[k] = { ...(a[k] || { opens: 0, max_step: 0, seconds: 0 }), opens: ((a[k] || {}).opens || 0) + 1, source: source || (a[k] || {}).source || "site", first_at: (a[k] || {}).first_at || now, last_at: now };
  write(a);
};

export const recordDemoWatch = (kind, step, seconds) => {
  const a = read(); const k = kind; const cur = a[k] || { opens: 0, max_step: 0, seconds: 0, source: "site", first_at: new Date().toISOString() };
  a[k] = { ...cur, max_step: Math.max(cur.max_step || 0, step), seconds: Math.max(cur.seconds || 0, Math.round(seconds)), last_at: new Date().toISOString() };
  write(a);
};

export const getDemoAttribution = () => { const a = read(); return Object.keys(a).length ? a : null; };
